module.exports = __webpack_public_path__ + "img/08陈攀峰.46e78d51.png";